// Country/city data sourced directly from the open "countries-states-cities-database"
// dataset (https://github.com/dr5hn/countries-states-cities-database) - the same data
// CountriesQL's GraphQL API (https://countriesql.com) is built from. Fetched straight
// from the dataset instead of through that hosted API so this feature doesn't depend on
// a third-party server's uptime.
const COUNTRIES_URL =
  'https://cdn.jsdelivr.net/gh/dr5hn/countries-states-cities-database@master/json/countries.json';
// The combined countries+states+cities file is ~46MB uncompressed (~4MB gzipped) - too
// large for jsDelivr's GitHub CDN size limit, so it's fetched from raw.githubusercontent.com
// instead. Loaded once per session and cached in memory since every country's cities live
// in this one file.
const FULL_DATASET_URL =
  'https://raw.githubusercontent.com/dr5hn/countries-states-cities-database/master/json/countries%2Bstates%2Bcities.json';

let fullDatasetPromise = null;

const loadFullDataset = () => {
  if (!fullDatasetPromise) {
    fullDatasetPromise = fetch(FULL_DATASET_URL).then(response => {
      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }
      return response.json();
    });
    fullDatasetPromise.catch(() => {
      // Let the next call retry instead of caching a rejected promise forever.
      fullDatasetPromise = null;
    });
  }
  return fullDatasetPromise;
};

// Returns [{ code, name, dial_code }] for every country.
export const fetchCountryDialCodes = () => {
  return fetch(COUNTRIES_URL)
    .then(response => {
      if (!response.ok) {
        throw new Error('HTTP ' + response.status);
      }
      return response.json();
    })
    .then(data =>
      data.map(country => ({
        code: country.iso2,
        name: country.name,
        dial_code: '+' + country.phonecode,
      })),
    )
    .catch(error => {
      console.log(error);
      return Promise.reject('fetchCountryDialCodes Call Error');
    });
};

// Returns [{ name, state, latitude, longitude }] for every known city in the given
// country (matched by ISO2 code).
export const fetchCitiesForCountry = countryCode => {
  return loadFullDataset()
    .then(countries => {
      const country = countries.find(c => c.iso2 === countryCode);
      if (!country || !country.states) {
        return [];
      }
      const cities = [];
      country.states.forEach(state => {
        (state.cities || []).forEach(city => {
          cities.push({
            name: city.name,
            state: state.name,
            latitude: parseFloat(city.latitude),
            longitude: parseFloat(city.longitude),
          });
        });
      });
      return cities;
    })
    .catch(error => {
      console.log(error);
      return Promise.reject('fetchCitiesForCountry Call Error');
    });
};
